export default __webpack_public_path__ + "static/media/Yotpo.6a89cd9f.png";